import React from "react";
import { useNavigate } from "react-router-dom";
import "../css.css";
import Footer from './Footer';
import Header from "./Header";
import { getCurrentAccount } from "../azure-auth";

const PreLogin = () => {
  const navigate = useNavigate();

  const handleAuthenticatedAgents = () => {
    const account = getCurrentAccount();
    if (account) {
      // User already has an authenticated session – go straight to dashboard
      navigate("/dashboard");
    } else {
      // No session – go to sign-in page
      navigate("/login");
    }
  };

  const handleNonAuthenticatedAgents = () => {
    navigate("/public-dashboard");
  };

  return (
    <>
      <style>{`
        .responsive-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 40px;
          max-width: 800px;
          margin: 0 auto;
        }
        
        @media (max-width: 768px) {
          .responsive-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
        }
        
        @media (max-width: 480px) {
          .responsive-grid {
            gap: 20px;
          }
        }
      `}</style>

      <Header />

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundImage: 'url("./images.jpg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        color: 'white',
        fontFamily: '"Poppins", sans-serif',
        padding: '20px'
      }}>
        <div className="container" style={{ maxWidth: '1000px', width: '100%' }}>
          <h1 style={{
            fontSize: '36px',
            marginBottom: '20px',
            fontWeight: '700',
            color: '#ffffff',
            letterSpacing: '2px',
            textAlign: 'center'
          }}>
            Welcome to Agent Store
          </h1>
          
          <p style={{
            fontSize: '18px',
            color: '#ccc',
            marginBottom: '50px',
            lineHeight: '1.6',
            textAlign: 'center'
          }}>
            Choose your access type to explore DigitalLab AI Agents
          </p>

          <div className="responsive-grid">
            {/* Authenticated Agents Box */}
            <div
              onClick={handleAuthenticatedAgents}
              className="access-type-card authenticated-card"
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '16px',
                padding: '40px 30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3), 0 0 15px rgba(34, 139, 34, 0.6)',
                minHeight: '280px',
                backdropFilter: 'blur(10px)',
                border: '2px solid rgba(34, 139, 34, 0.3)'
              }}
            >
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #4CAF50, #45a049)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '25px',
                fontSize: '32px',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)'
              }}>
                <img width="60" height="60" src="https://img.icons8.com/3d-fluency/94/lock-2.png" alt="lock-2"/>
              </div>
              
              <h3 style={{
                fontSize: '24px',
                fontWeight: '600',
                color: '#fff',
                marginBottom: '15px',
                lineHeight: '1.3'
              }}>
                Authenticated Agents
              </h3>
              
              <p style={{
                fontSize: '16px',
                color: '#ccc',
                lineHeight: '1.5',
                marginBottom: '20px'
              }}>
                Access secure, personalized AI agents with full features and capabilities. Sign in required.
              </p>
              
              <div style={{
                background: 'rgba(76, 175, 80, 0.2)',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                color: '#4CAF50',
                fontWeight: '600'
              }}>
                Login Required
              </div>
            </div>

            {/* Non-Authenticated Agents Box */}
            <div
              onClick={handleNonAuthenticatedAgents}
              className="access-type-card public-card"
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '16px',
                padding: '40px 30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3), 0 0 15px rgba(0, 76, 255, 0.6)',
                minHeight: '280px',
                backdropFilter: 'blur(10px)',
                border: '2px solid rgba(0, 76, 255, 0.3)'
              }}
            >
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg,rgb(51, 123, 255),rgb(67, 133, 255))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '25px',
                fontSize: '32px',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)'
              }}>
                <img width="60" height="60" src="https://img.icons8.com/3d-fluency/94/globe.png" alt="globe"/>
              </div>
              
              <h3 style={{
                fontSize: '24px',
                fontWeight: '600',
                color: '#fff',
                marginBottom: '15px',
                lineHeight: '1.3'
              }}>
                Public Agents
              </h3>
              
              <p style={{
                fontSize: '16px',
                color: '#ccc',
                lineHeight: '1.5',
                marginBottom: '20px'
              }}>
                Explore publicly available AI agents with basic features. No login needed.
              </p>
              
              <div style={{
                background: 'rgba(46, 79, 228, 0.2)',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                color: '#727bf9',
                fontWeight: '600'
              }}>
                Free Access
              </div>
            </div>
          </div>

          <div style={{
            marginTop: '40px',
            padding: '20px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <p style={{ 
              color: '#ccc', 
              fontSize: '14px', 
              margin: 0,
              lineHeight: '1.5'
            }}>
              Need help? Contact our DigitalLab support team for assistance with agent access and features.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PreLogin;